import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Menu, X, Globe } from 'lucide-react';

const Navbar: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { t, i18n } = useTranslation();

  const toggleLanguage = () => {
    i18n.changeLanguage(i18n.language === 'en' ? 'ar' : 'en');
  };

  return (
    <nav className="fixed w-full z-50 bg-white/90 backdrop-blur-md shadow-sm border-b border-slate-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-20">
          <div className="flex items-center">
            <div className="flex-shrink-0 flex items-center cursor-pointer">
              <img 
                src={i18n.language === 'ar' ? '/logos/haj-ar.svg' : '/logos/haj-en.svg'} 
                alt="Haj Logistics" 
                className="h-12 w-auto"
              />
            </div>
          </div>
          
          <div className="hidden md:flex items-center space-x-8">
            <a href="#services" className="text-slate-600 hover:text-marine-600 font-medium transition-colors">{t('navbar.services')}</a>
            <a href="#about" className="text-slate-600 hover:text-marine-600 font-medium transition-colors">{t('navbar.about')}</a>
            <button onClick={toggleLanguage} className="flex items-center gap-2 text-slate-600 hover:text-marine-600">
              <Globe className="h-4 w-4" />
              <span>{t('navbar.lang_toggle')}</span>
            </button>

          </div>

          <div className="flex items-center md:hidden">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="text-slate-600 hover:text-marine-600 focus:outline-none"
            >
              {isOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      {isOpen && (
        <div className="md:hidden bg-white border-b border-slate-100">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
            <a href="#services" className="block px-3 py-2 text-slate-600 hover:text-marine-600 hover:bg-slate-50 rounded-md font-medium">{t('navbar.services')}</a>
            <a href="#about" className="block px-3 py-2 text-slate-600 hover:text-marine-600 hover:bg-slate-50 rounded-md font-medium">{t('navbar.about')}</a>
            <a href="#contact" className="block w-full text-center mt-4 bg-marine-600 text-white px-6 py-3 rounded-lg font-semibold">
              {t('navbar.contact')}
            </a>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
